var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.319,297.16c15.281,0,27.713-12.431,27.713-27.712s-12.432-27.712-27.713-27.712s-27.713,12.431-27.713,27.712   S240.038,297.16,255.319,297.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.621,327.135h-28.401c-27.985,0-50.752,22.766-50.752,50.75v1.48c19.798,10.404,41.95,15.926,64.953,15.926   s45.155-5.522,64.953-15.926v-1.48C320.373,349.901,297.606,327.135,269.621,327.135z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 120.647,
    y1: 491.301,
    x2: 120.648,
    y2: 491.301
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 491.3,
    y1: 120.642,
    x2: 491.3,
    y2: 120.642
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 491.3,
    y1: 491.301,
    x2: 491.3,
    y2: 491.301
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.3,391.358c-13.349-13.348-31.096-20.699-49.974-20.699c-13.775,0-26.94,3.931-38.241,11.233l-38.723-38.723   c20.047-24.787,30.946-55.434,30.946-87.76c0-32.273-10.864-62.871-30.848-87.637l38.508-37.737   c11.327,7.351,24.536,11.307,38.358,11.307c18.878,0,36.625-7.351,49.973-20.699C504.648,107.294,512,89.547,512,70.67   s-7.352-36.624-20.7-49.972C477.951,7.351,460.204,0,441.326,0c-18.878,0-36.626,7.351-49.974,20.699   c-13.349,13.348-20.7,31.095-20.7,49.972c0,13.729,3.906,26.85,11.162,38.126l-38.528,37.756   c-24.806-20.099-55.494-31.027-87.866-31.027c-32.093,0-62.53,10.742-87.223,30.511l-38.01-37.242   c7.255-11.275,11.161-24.396,11.161-38.124c0-18.877-7.352-36.624-20.7-49.972c-27.555-27.554-72.392-27.554-99.948,0   c-27.555,27.554-27.555,72.389,0,99.943c13.348,13.348,31.096,20.699,49.974,20.699c13.823,0,27.031-3.957,38.359-11.308   l37.861,37.096c-20.315,24.877-31.362,55.728-31.362,88.279c0,32.605,11.083,63.505,31.463,88.404l-38.079,38.08   c-11.302-7.302-24.466-11.233-38.241-11.233c-18.878,0-36.626,7.351-49.974,20.699C7.351,404.706,0,422.452,0,441.33   c0,18.877,7.351,36.623,20.7,49.971C34.048,504.649,51.796,512,70.674,512s36.625-7.351,49.973-20.699   c13.349-13.348,20.7-31.095,20.7-49.972c0-13.776-3.932-26.941-11.236-38.243l30.578-30.579   c2.035-30.768,21.374-56.87,48.361-68.643c-7.171-9.614-11.421-21.528-11.421-34.417c0-31.809,25.879-57.687,57.689-57.687   s57.689,25.878,57.689,57.687c0,12.858-4.232,24.745-11.372,34.348c26.699,11.581,45.941,37.177,48.417,67.456l31.834,31.834   c-7.304,11.302-11.236,24.467-11.236,38.243c0,18.877,7.352,36.623,20.7,49.971C404.701,504.649,422.448,512,441.326,512   c18.878,0,36.625-7.351,49.973-20.699c13.349-13.348,20.7-31.095,20.7-49.972C512,422.452,504.648,404.706,491.3,391.358z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.148da472c837a2166a52eac81b3e7b04.svg";
export { ForwardRef as ReactComponent };